/** Reference account for Phase 1 acceptance (docs/operations/13-customer-optimization-wiring.md). */
export type { PinnedCustomerOpsAccount } from '@/lib/customer-ops/fleet-accounts';

export {
  CUSTOMER_OPS_PORTFOLIO_ACCOUNTS as PINNED_CUSTOMER_OPS_ACCOUNTS,
  buildFleetCustomerOpsAccounts,
  getFleetLocationNumbers,
} from '@/lib/customer-ops/fleet-accounts';

import { CUSTOMER_OPS_PORTFOLIO_ACCOUNTS } from '@/lib/customer-ops/fleet-accounts';

export const LAZY_RIVER_LOCATION_NUMBERS = ['LOC-040', 'LOC-041'] as const;

export const LAZY_RIVER_PRIMARY_LOCATION_NUMBER = 'LOC-040';

export function getAllPinnedLocationNumbers(): string[] {
  return CUSTOMER_OPS_PORTFOLIO_ACCOUNTS.flatMap((account) => [...account.locationNumbers]);
}

export const CUSTOMER_OPS_FLYWHEEL_STEPS = [
  { label: 'Pulse', description: 'Store performance reports' },
  { label: 'Campaign', description: 'Improvement on the floor' },
  { label: 'Proof', description: 'Approved claims' },
  { label: 'Review', description: 'Scheduled readouts & QBRs' },
  { label: 'Improve', description: 'Next cycle' },
] as const;

/** Static comms tone default per operations/01 (no playbook doc in Phase 1). */
export const CUSTOMER_OPS_COMMS_TONE_DEFAULT = `Comms tone:
- Listen first; lead with metrics
- No renewal-conditional product delivery
- No arguing with customer-read data
- Product truth tags on all external comms`;
